// tenant/feedback.js
import { http } from "../base"


/**
 * 获取反馈会话列表（按会话聚合）
 */
export async function getFeedbackSessions(params) {
  console.log("getFeedbackSessions", params)
  try {
    const response = await http.get('/aics/feedback/sessions', { params })
    return response.data
  } catch (error) {
    console.error("获取反馈会话列表失败:", error)
    throw error
  }
}


/**
 * 获取反馈详情（通过会话ID）
 * @param {string} conversationId - 会话ID，格式如 "FB_1772796058448_12"
 */
export async function getFeedbackDetail(conversationId) {  
  try {
    const response = await http.get(`/aics/feedback/conversation/${conversationId}`)
    return response.data
  } catch (error) {
    console.error("获取反馈详情失败:", error)
    throw error
  }
}

/**
 * 提交反馈
 */
export async function submitFeedback(data) {
  try {
    const response = await http.post('/aics/feedback/submit', data)
    return response.data
  } catch (error) {
    console.error("提交反馈失败:", error)
    throw error
  }
}

/**
 * 回复反馈
 */
export async function replyFeedback(data) {
  try {
    const response = await http.post('/aics/feedback/reply', data)
    return response.data
  } catch (error) {
    console.error("回复反馈失败:", error)
    throw error
  }
}

/**
 * 关闭反馈
 */
export async function closeFeedback(feedbackId) {
  try {
    const response = await http.put(`/aics/feedback/close/${feedbackId}`)
    return response.data
  } catch (error) {
    console.error("关闭反馈失败:", error)
    throw error
  }
}

/**
 * 批量关闭反馈
 */
export async function batchCloseFeedback(feedbackIds) {
  try {
    const response = await http.put('/aics/feedback/close/batch', feedbackIds)
    return response.data
  } catch (error) {
    console.error("批量关闭反馈失败:", error)
    throw error
  }
}